<div class="dialog dialog-medium dialog-flex-direction-column">
    <h4 class="dialog-inner h4-blue">Unable to Offer Coverage at This Time</h4>
    <div class="dialog-inner">Thank you for your interest in our High Limits Disability Insurance. Unfortunately, based
        on the earnings, existing coverage, and other information provided, we are unable to offer coverage at this
        time. Please contact your broker if you have any questions or to discuss potential alternatives.</div>

    <div class="dialog-inner-buttons">
        <button class="button-mgis" (click)="close()" class="chat-button chat-button-define" mat-flat-button>Done</button>
    </div>